// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 846 ? "e9c979fe" : chunkId) + "." + {"118":"961c414e71ec2ca4","203":"717de92c7a4e2901","846":"4ce64128a36dbd16","910":"d6096feac894af5e"}[chunkId] + ".js";
};